
<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import OrderHistoryList from "@/router/views/menu/order/OrderHistoryList";
import OrderTableDetails from "@/components/OrderTableDetails.vue";


/**
 * Reporting component
 */
export default {
  page: {
    title: "OrderHistory",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout, OrderHistoryList, OrderTableDetails},

  data() {
    return {
      selectedTableNumber: null,
      selectedOrderId: null,
      isMobile: false,
      orderTableDetailsKey:0,
      showModalOrderDetails: false

    }
  },

  mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
        this.$nextTick(() => {
      const mainContent = document.querySelector(".main-content");
      if (mainContent) {
        mainContent.style.overflow = "visible";
      }
    });
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
    if (this.ordersIntervalId) {
      clearInterval(this.ordersIntervalId);
    }
  },

  methods:{
    onSelectedTableNumber(orderTable) {
      this.selectedTableNumber= orderTable.tableNumber,
      this.selectedOrderId= orderTable.id,
      this.orderTableDetailsKey++,
      this.showModalOrderDetails= this.isMobile
    },
    checkScreenSize() {
      this.isMobile = window.innerWidth < 576; 
    },

    closeDetails(){
      this.selectedTableNumber = null
      this.selectedOrderId = null
      this.showModalOrderDetails= false
    },
  }

};
</script>

<template>
  <Layout>

    <div class="row d-flex flex-nowrap px-3">
      <div
        class="archived-transition-col-left mr-md-2 mr-0" style="min-height: 65vh !important;"
        :class="{ 'shrink': !isMobile && selectedTableNumber, 'full': isMobile || !selectedTableNumber }">
        <div class="card">
          <div class="card-body">
            <OrderHistoryList   @update:selectedTableNumber="onSelectedTableNumber" />
          </div>
        </div>
      </div>

      <div class="archived-transition-col-right bg-white border rounded shadow d-none d-sm-block ml-md-2 ml-0"
        :class="{ visible: selectedTableNumber, hidden: !selectedTableNumber }">
        <OrderTableDetails ref="orderDetailsRef" class="p-3 " v-if="selectedTableNumber" 
        :tableNumber="selectedTableNumber ? selectedTableNumber : null " 
        :orderTableId="selectedOrderId ? selectedOrderId  : null "  
        :isArchivedOrder="true"  
        @cancel="closeDetails()"
        :key="orderTableDetailsKey" />
      </div>
    </div>

    <b-modal
      v-model="showModalOrderDetails"
      centered
      hide-header
      hide-footer
      size="sm"
      @hide="showModalOrderDetails = false"
    >
        <OrderTableDetails ref="orderDetailsRef" class="p-3 " v-if="selectedTableNumber" 
        :tableNumber="selectedTableNumber ? selectedTableNumber : null " 
        :orderTableId="selectedOrderId ? selectedOrderId  : null "  
        :isArchivedOrder="true"  
        @cancel="closeDetails()"
        :key="orderTableDetailsKey" />

    </b-modal>

  </Layout>
</template>


<style scoped>

.row.d-flex {
  flex-wrap: nowrap;
}

.archived-transition-col-left {
  transition: width 0.5s ease, padding 0.3s ease, margin 0.3s ease;
}

.archived-transition-col-left.full {
  width: 100%;
}

.archived-transition-col-left.shrink {
  width: 50%;
}

@media (min-width: 768px) {
  .archived-transition-col-left.shrink {
    width: 60%;
  }
}

@media (min-width: 992px) {
  .archived-transition-col-left.shrink {
    width: 60%;
  }
}

@media (min-width: 1200px) {
  .archived-transition-col-left.shrink {
    width: 75%;
  }
}

.archived-transition-col-right {
  position: sticky;
  top: 4rem;
  max-height: calc(100vh - 2rem);
  overflow-y: auto;
  transition: width 0.5s ease, opacity 0.5s ease;
  width: 100%;
  opacity: 0;
  pointer-events: none;
}

/* Visible state */
.archived-transition-col-right.visible {
  opacity: 1;
  pointer-events: auto;
}

@media (max-width: 767.98px) {
  .archived-transition-col-right.visible {
    width: 50%;
    order: 1;
    margin-bottom: 1rem;
  }
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .archived-transition-col-right.visible {
    width: 40%;
  }
}

@media (min-width: 992px) {
  .archived-transition-col-right.visible {
    width: 40%;
  }
}

@media (min-width: 1200px) {
  .archived-transition-col-right.visible {
    width: 25%;
  }
}

.archived-transition-col-right.hidden {
  width: 0;
  opacity: 0;
  pointer-events: none;
}

@keyframes blink-opacity {
  0%, 100% {
    opacity: 1;
  }
  20% {
    opacity: 0;
  }
}


.blinking-badge {
  animation: blink-opacity 1s infinite;
}
</style>